(() => {
  if (customElements.get('poleward-region-drawer')) return;

  customElements.define('poleward-region-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.dialog) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-region-drawer-open]');
      if (!this.dialog || !this.trigger) return;
      this.desktopTarget = this.dialog.querySelector('[data-localization-desktop-target]');
      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.trigger.addEventListener('click', () => this.open(), options);
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-pw-region-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      }, options);
      this.dialog.querySelector('[data-region-drawer-close]')?.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        const selector = this.dialog.querySelector('.localization-form__select[aria-expanded="true"]');
        if (selector) {
          selector.closest('localization-form')?.hidePanel?.();
          selector.focus();
          return;
        }
        this.close();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
      }, options);
      this.dialog.addEventListener('transitionend', (event) => {
        if (event.target === this.dialog && event.propertyName === 'transform' && this.closing) this.finishClose();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.dialog.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.returnTarget?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('poleward-region-drawer-open');
        this.restoreForms();
      }, options);
      this.desktopMedia.addEventListener('change', () => {
        if (!this.desktopMedia.matches && this.returnTarget === this.trigger) this.close({ immediate: true, returnFocus: false });
      }, options);
      document.body.append(this.dialog);
    }

    disconnectedCallback() {
      this.listeners?.abort();
      window.cancelAnimationFrame(this.frame);
      window.clearTimeout(this.closeTimer);
      if (!this.dialog) return;
      this.closeSelectors();
      this.restoreForms();
      this.dialog.classList.remove('is-open');
      this.dialog.close();
      document.body.classList.remove('poleward-region-drawer-open');
      this.append(this.dialog);
      this.dialog = undefined;
      this.desktopTarget = undefined;
    }

    open(trigger = this.trigger) {
      if (!this.desktopMedia.matches && !trigger.matches('[data-pw-region-open]')) return;
      window.clearTimeout(this.closeTimer);
      this.closing = false;
      this.returnTarget = trigger;
      trigger.setAttribute('aria-controls', this.dialog.id);
      trigger.setAttribute('aria-expanded', 'true');
      this.desktopTarget.dataset.localizationInDrawer = 'true';
      this.syncForms();
      if (!this.dialog.open) this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('poleward-region-drawer-open');
      this.dialog.getBoundingClientRect();
      window.cancelAnimationFrame(this.frame);
      this.frame = window.requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close({ immediate = false, returnFocus = true } = {}) {
      if (!this.dialog?.open) return;
      window.cancelAnimationFrame(this.frame);
      window.clearTimeout(this.closeTimer);
      this.returnFocus = returnFocus;
      this.closing = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.returnTarget?.setAttribute('aria-expanded', 'false');
      const entered = this.dialog.classList.contains('is-open');
      this.dialog.classList.remove('is-open');
      if (immediate || this.reducedMotion.matches || !entered) {
        this.finishClose();
        return;
      }
      this.closeTimer = window.setTimeout(() => this.finishClose(), 300);
    }

    closeSelectors() {
      this.desktopTarget?.querySelectorAll('localization-form').forEach((form) => {
        const selector = form.querySelector('.localization-form__select[aria-expanded="true"]');
        if (!selector) return;
        if (document.querySelector('.menu-drawer')) {
          form.hidePanel?.();
        } else {
          selector.setAttribute('aria-expanded', 'false');
          form.querySelector('.disclosure__list-wrapper')?.setAttribute('hidden', '');
          document.body.classList.remove('overflow-hidden-mobile');
        }
      });
    }

    syncForms() {
      document.dispatchEvent(new CustomEvent('poleward:localization-drawer-change', {
        detail: { target: this.desktopTarget },
      }));
    }

    restoreForms() {
      if (this.desktopTarget?.dataset.localizationInDrawer !== 'true') return;
      delete this.desktopTarget.dataset.localizationInDrawer;
      this.syncForms();
    }

    finishClose() {
      if (!this.closing) return;
      this.closing = false;
      window.clearTimeout(this.closeTimer);
      this.closeSelectors();
      this.dialog.close();
      this.restoreForms();
      document.body.classList.remove('poleward-region-drawer-open');
      if (!this.returnFocus || !this.returnTarget?.isConnected) return;
      if (this.returnTarget === this.trigger && !this.desktopMedia.matches) return;
      const menu = this.returnTarget.closest('details.mega-menu');
      if (menu) menu.open = true;
      this.returnTarget.focus({ preventScroll: true });
    }
  });
})();
